import * as React from "react";
import type { SVGProps } from "react";
const SvgCrown = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.266 10.511c.252-.681 1.216-.681 1.468 0l.35.944c.078.214.247.383.462.462l.943.349c.681.252.681 1.216 0 1.468l-.943.35a.78.78 0 0 0-.463.462l-.349.943c-.252.681-1.216.681-1.468 0l-.35-.943a.78.78 0 0 0-.462-.463l-.943-.349c-.681-.252-.681-1.216 0-1.468l.943-.35a.78.78 0 0 0 .463-.462zm1.17 2.49q-.248.187-.436.435a2.3 2.3 0 0 0-.436-.436q.248-.188.436-.436.188.248.436.436"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.574 4.522c-.638-1.313-2.51-1.313-3.148 0L7.365 10.82a.25.25 0 0 1-.357.104L4.71 9.504c-1.386-.854-3.086.48-2.584 2.03l2.236 6.898a1.764 1.764 0 0 0 1.898 1.203c1.326-.166 3.912-.456 5.741-.456s4.415.29 5.74.456a1.764 1.764 0 0 0 1.9-1.203l2.235-6.898c.502-1.55-1.198-2.884-2.584-2.03l-2.3 1.42a.25.25 0 0 1-.355-.104zm-1.799.656a.25.25 0 0 1 .45 0l3.062 6.298a1.75 1.75 0 0 0 2.492.724l2.3-1.419a.25.25 0 0 1 .369.29l-2.236 6.899a.264.264 0 0 1-.285.177c-1.322-.166-3.993-.468-5.927-.468s-4.605.302-5.927.468a.264.264 0 0 1-.285-.177L3.552 11.07a.25.25 0 0 1 .37-.29l2.299 1.42a1.75 1.75 0 0 0 2.493-.725z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCrown;
